import React from 'react';
import { Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-bp-bg border-t border-bp-line py-16 px-6 md:px-20" data-id="element-34">
      <div className="max-w-container mx-auto" data-id="element-35">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-36">
          {/* Left Column */}
          <div data-id="element-37">
            <div className="mb-6" data-id="element-38">
              <h3 className="font-display text-3xl text-bp-text tracking-wider uppercase mb-2" data-id="element-39">
                BAJO PERFIL
              </h3>
            </div>
            <div className="space-y-1" data-id="element-40">
              <p className="font-body font-light text-bp-text2 text-sm" data-id="element-41">
                Street food.
              </p>
              <p className="font-body font-light text-bp-text2 text-sm" data-id="element-42">
                Ingredientes reales.
              </p>
              <p className="font-body font-light text-bp-text2 text-sm" data-id="element-43">
                Pasto, Colombia.
              </p>
            </div>
          </div>

          {/* Right Column */}
          <div className="flex flex-col justify-end" data-id="element-44">
            <div className="space-y-3" data-id="element-45">
              <a href="https://instagram.com/bajoperfil.pasto" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-bp-text2 no-underline hover:text-bp-accent transition-colors duration-300" data-id="element-46">
                <Instagram className="w-5 h-5" data-id="element-47" />
                <span className="font-body font-light text-sm" data-id="element-48">
                  @bajoperfil.pasto
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-bp-line pt-6" data-id="element-49">
          <p className="font-body font-light text-bp-line text-xs text-center" data-id="element-50">
            © BAJO PERFIL 2026
          </p>
        </div>
      </div>
    </footer>;
}